// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__l8Uny","question":"FAQ_question__t4UaQ","answer":"FAQ_answer__3feA6","closed":"FAQ_closed__59f6r","open":"FAQ_open__Iz+N8"};